import http from '../../http-common';

class EventPracticeRegistrantService {
    getAll(eventId, practiceId) {
        return http.get(`/promoter/eventDetails/${eventId}/practice/${practiceId}/registrants`);
    }
}


export default new EventPracticeRegistrantService();
